import type { EvaluationScore } from "@chessla/shared";

/** Stored checkpoints start after the first continuation move and use the original mover's perspective. */
export const continuationEvaluationForWhite = (
  startingFen: string,
  stepIndex: number,
  scores: readonly EvaluationScore[] | null,
  legacyEvals: readonly number[] | null,
  initial: EvaluationScore | null,
): EvaluationScore | null => {
  if (stepIndex <= 0) return initial;
  let score: EvaluationScore | null = null;
  if (scores != null) score = scores[stepIndex - 1] ?? null;
  else {
    const cp = legacyEvals?.[stepIndex - 1];
    if (cp == null || Math.abs(cp) === 10_000) return null;
    score = { cp, mate: null };
  }
  if (!score) return null;
  const multiplier = startingFen.split(" ")[1] === "b" ? -1 : 1;
  return {
    cp: score.mate == null && score.cp != null ? (score.cp === 0 ? 0 : score.cp * multiplier) : null,
    mate: score.mate == null ? null : score.mate * multiplier,
  };
};
